import React, {MouseEventHandler, ReactElement, useState} from 'react';
import {Link} from '@taopix/taopix-design-system';

export type AssetServiceAlbumThumbnailProps = {
  albumId: string;
  imgSource: string | ReactElement;
  albumName: string;
  onSelect: MouseEventHandler;
};

const AssetServiceAlbumThumbnail = ({
  albumId: folderId,
  imgSource,
  albumName,
  onSelect,
  ...props
}: AssetServiceAlbumThumbnailProps) => {
  const [loaded, setLoaded] = useState(typeof imgSource === 'string' ? false : true);

  const loadFunc = () => {
    setLoaded(true);
  };

  return (
    <li className="">
      <Link onClick={onSelect} disableStyling className={''}>
        <span className="flex relative w-[160rem] h-[160rem] overflow-hidden rounded-xs">
          {typeof imgSource === 'string' ? (
            <>
              <div
                className="bg-[#c1c1c1] w-[160rem] h-[160rem]"
                style={!loaded ? {} : {display: 'none'}}
              ></div>
              <img
                style={loaded ? {} : {display: 'none'}}
                alt={albumName}
                src={imgSource}
                className="object-cover h-[160rem] w-[160rem]"
                onLoad={loadFunc}
              />
            </>
          ) : (
            <div className="flex flex-auto">{imgSource}</div>
          )}
        </span>
        <span className={'block text-standard dark:text-standard-dark text-left mt-sm'}>
          {albumName}
        </span>
      </Link>
    </li>
  );
};

export default AssetServiceAlbumThumbnail;
